<template>
  <div class="thinking-depth-popover" :class="{ open: thinkingDepthPickerOpen }" v-show="thinkingDepthPickerOpen">
    <div class="thinking-depth-list">
      <button
        v-for="tier in availableTiers"
        :key="tier.value"
        class="thinking-depth-item"
        :class="{ active: thinkingDepth === tier.value }"
        type="button"
        @click="select(tier.value)"
      >
        <span class="thinking-depth-dot" :style="{ background: tier.color }"></span>
        <span class="thinking-depth-name">{{ tier.label }}</span>
        <span class="thinking-depth-sub">{{ tier.sub }}</span>
      </button>
      <div v-if="!availableTiers.length" class="thinking-depth-empty">当前模型暂无可选深度</div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'

const COLOR_MAP = {
  off: '#c0c8d4',
  minimal: '#a0aec0',
  low: '#68d391',
  medium: '#f6c343',
  high: '#4e9aff',
  xhigh: '#7c5cfc',
  adaptive: '#38c8c8'
}

export default {
  name: 'ThinkingDepthPopover',
  computed: {
    ...mapState(['thinkingDepthPickerOpen', 'thinkingDepthPickerRect', 'thinkingDepth']),
    ...mapGetters(['currentModelThinks']),
    availableTiers() {
      if (this.currentModelThinks.length) {
        return this.currentModelThinks.map(t => ({
          value: t.name,
          label: t.description || t.name,
          sub: t.name,
          color: COLOR_MAP[t.name] || '#94a3b8'
        }))
      }
      // 降级：无接口数据时显示默认选项
      return [
        { value: 'off', label: '关闭', sub: 'off', color: '#c0c8d4' },
        { value: 'medium', label: '标准', sub: 'medium', color: '#f6c343' },
        { value: 'high', label: '深度', sub: 'high', color: '#4e9aff' },
      ]
    }
  },
  watch: {
    thinkingDepthPickerOpen(val) {
      if (val) this.$nextTick(() => this.applyPosition())
    }
  },
  methods: {
    ...mapMutations(['SET_THINKING_DEPTH_PICKER_OPEN']),
    select(value) {
      this.$store.dispatch('selectThinkingDepth', value)
      this.SET_THINKING_DEPTH_PICKER_OPEN(false)
    },
    applyPosition() {
      const rect = this.thinkingDepthPickerRect
      if (!rect || !this.$el) return
      const width = 200
      const popoverHeight = this.$el.offsetHeight || 280
      const left = Math.min(window.innerWidth - width - 16, Math.max(16, rect.left))
      const preferDownTop = rect.bottom + 8
      const preferUpTop = rect.top - popoverHeight - 8
      const canOpenDownward = preferDownTop + popoverHeight <= window.innerHeight - 12
      const openUpward = !canOpenDownward && preferUpTop >= 12
      const top = openUpward ? preferUpTop : Math.min(window.innerHeight - popoverHeight - 12, Math.max(12, preferDownTop))
      this.$el.style.left = `${left}px`
      this.$el.style.top = `${top}px`
    },
    handleGlobalClick(e) {
      if (this.thinkingDepthPickerOpen && !this.$el.contains(e.target)) {
        this.SET_THINKING_DEPTH_PICKER_OPEN(false)
      }
    }
  },
  mounted() {
    this.$nextTick(() => { document.addEventListener('click', this.handleGlobalClick) })
    this.$nextTick(() => this.applyPosition())
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleGlobalClick)
  }
}
</script>
